import { Box, Typography } from '@mui/material'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'

const getReqMessage = (message?: string, shortForm?: boolean) => {
  const { t } = useTranslation()
  if (message) {
    return t(message)
  }
  if (shortForm) {
    return t('shortFormReq')
  }
  return t('required')
}

export const RequiredLabel = ({
  inputLabel,
  shortForm,
  message,
}: {
  inputLabel: string
  shortForm?: boolean
  message?: string
}) => {
  const { t } = useTranslation()
  return (
    <Box
      display='flex'
      sx={{
        zIndex: 1,
        color: 'inherit',
      }}>
      <Typography variant='body2' sx={{ color: theme.palette.text.secondary }}>
        {t(inputLabel)}
      </Typography>
      <Typography
        sx={{
          fontStyle: 'italic',
          lineHeight: 1.43,
          color: theme.palette.text.secondary,
        }}>
        ({getReqMessage(message, shortForm)})
      </Typography>
    </Box>
  )
}
